<div [formGroup]="form()">
  @if (hasIcon()) {
    <mat-icon matPrefix [matTooltip]="getToolTipText()">{{ iconName() }}</mat-icon>
  }
  <mat-checkbox [formControlName]="controlName()"></mat-checkbox>
</div>
